import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-arrow-down-circle",
  "use": "gw-arrow-down-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-arrow-down-circle\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm-3.7 8.3a.996.996 0 0 0 0 1.41l3.17 3.18c.39.39 1.02.39 1.41 0l3.17-3.17a.996.996 0 1 0-1.41-1.41l-2.47 2.45-2.46-2.46a.996.996 0 0 0-1.41 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol